import { BusinessAccessLevelEnum } from '@/services/types/Account';
import { EnumValues } from '@/services/types/EnumValues';
import { AccountType, AccountTypeEnum } from '@/context/types/Account';

type TAccessLevel = EnumValues<typeof BusinessAccessLevelEnum>;

export const getAccessLevelDisplay = (
  accountType: AccountType | undefined,
  accessLevel: TAccessLevel | undefined
): string => {
  const raw =
    accountType === AccountTypeEnum.PERSONAL || !accessLevel
      ? BusinessAccessLevelEnum.OWNER
      : accessLevel;
  return raw
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};
